import styled from "styled-components";
import theme from "~/styles/theme";

export const Modal = styled.div`
  background: #fff;
  position: fixed;
  z-index: 1000;

  bottom: 0;
  width: 100%;
  height: fit-content;
  border-radius: 16px 16px 0 0;
  
  @media (min-width: ${theme.breakpoints.values.md}px) {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 550px;
    border-radius: 16px;
  }
`;
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0,0,0,.9);
`;

export const ContentModal = styled.div`
  padding: 40px 16px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 64px 40px;
  }
`;

export const Links = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  a {
    color: var(--Neutral-Gray-900, #1B1B19);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`;

export const Title = styled.div`
  color: var(--cores-0D5BA8, #0D5BA8);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 16px;
`;

export const Text = styled.div`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-bottom: 24px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 40px;
  }
`;

export const Button = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 32px;
  background: var(--cores-0D5BA8, #0D5BA8);
  cursor: pointer;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 100% */
  text-transform: uppercase;
  margin-bottom: 24px;
  
  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 40px;
  }

`;
